<div class="modal-body text-center">
  <h6 class="modal-title mb-4">Warning</h6>
  <p>You have unsaved changed. Are you sure you want to continue?</p>
  <button type="button" class="btn btn-primary m-2" (click)="confirm()">Yes</button>
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">No</button>
</div>
